import React, { useState, useEffect } from "react";
import { FaUser, FaLock } from "react-icons/fa";
import { useStoreLogin } from "../../store/login";
import { useStoreLoader } from "../../store/loader";

export default function LoginPassword({ changeScreen, onClose }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const isloading = useStoreLoader((state) => state.isloading);
  const [errorMessage, setErrorMessage] = useState("");
  const [page, setPage] = useState(1);
  let user = useStoreLogin.getState().user;
  let authToken = useStoreLogin.getState().authToken;
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (validate()) {
      try {
        setLoading(true);
        if (username && password) {
          await useStoreLogin.getState().login({ username, password });
        }
      } catch (err) {
        console.log("Error", err);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    if (user && authToken) {
      setPage(2);
      onClose && onClose();
    }
  }, [user, authToken]);

  useEffect(() => {
    if (Object.keys(errorMessage).length > 0) {
      const timer = setTimeout(() => setErrorMessage({}), 2000);
      return () => clearTimeout(timer);
    }
  }, [errorMessage]);

  const validate = () => {
    const errors = {};
    if (!username) errors.username = "Username is required";
    if (!password) errors.password = "Password is required";
    setErrorMessage(errors);
    return Object.keys(errors).length === 0;
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[12rem]">
        <div className="border-gray-200 border-t-[#FFD338] w-[48px] h-[48px] animate-spin rounded-full border-4 border-solid"></div>
      </div>
    );
  }

  if (page === 2) {
    return (
      <div className="text-center py-8 px-5">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <p className="font-bold text-lg text-[#052c24]">Login Successful!</p>
      </div>
    );
  }

  return (
    <div className="px-5 py-4">
      {/* Username */}
      <label className="block text-sm font-semibold text-[#052c24] mb-1">
        Reg. Mobile no. <span className="text-red-500">*</span>
      </label>
      <div className="flex items-center border border-[#052c24] rounded-lg px-3 py-2 mb-2 bg-white focus-within:ring-2 focus-within:ring-[#FFD338] transition-all">
        <FaUser className="text-[#052c24] mr-2 text-sm" />
        <input
          className="w-full outline-none text-sm bg-transparent placeholder-gray-400"
          value={username}
          placeholder="Enter your mobile number"
          onChange={(e) => setUsername(e.target.value)}
        />
      </div>
      {errorMessage?.username && (
        <p className="text-red-500 text-xs mb-2">{errorMessage.username}</p>
      )}

      {/* Password */}
      <label className="block text-sm font-semibold text-[#052c24] mb-1">
        Password <span className="text-red-500">*</span>
      </label>
      <div className="flex items-center border border-[#052c24] rounded-lg px-3 py-2 mb-2 bg-white focus-within:ring-2 focus-within:ring-[#FFD338] transition-all">
        <FaLock className="text-[#052c24] mr-2 text-sm" />
        <input
          className="w-full outline-none text-sm bg-transparent placeholder-gray-400"
          value={password}
          type="password"
          placeholder="Enter your password"
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>
      {errorMessage?.password && (
        <p className="text-red-500 text-xs mb-2">{errorMessage.password}</p>
      )}

      {/* Buttons */}
      <div className="flex items-center justify-between mt-4">
        <button
          className="bg-[#FFD338] hover:bg-[#d6aa08] text-[#052c24] font-semibold px-6 py-2 rounded-lg border border-black shadow-[0px_4px_10px_rgba(0,0,0,0.3)] transition-all text-sm"
          onClick={handleLogin}
        >
          Login
        </button>
        <button
          className="bg-[#FFD338] hover:bg-[#d6aa08] text-[#052c24] font-semibold px-6 py-2 rounded-lg border border-black shadow-[0px_4px_10px_rgba(0,0,0,0.3)] transition-all text-sm"
          onClick={() => changeScreen("REGISTER")}
        >
          Register
        </button>
      </div>

      {/* Forgot password */}
      <div className="text-right mt-3 pb-3">
        <button
          className="text-sm text-[#052c24] hover:text-[#FFD338] underline font-medium transition-colors"
          onClick={() => changeScreen("FORGOT_PASSWORD")}
        >
          Forgot password?
        </button>
      </div>
    </div>
  );
}
